<template>
    <div>
        <div v-show="pageType == 1">
            <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form">
                <el-form-item label="项目名：" class="query-form-item">
                    <el-input v-model="query.name" placeholder="请输入项目名"></el-input>
                </el-form-item>

                <el-form-item label="" class="query-form-item">
                    <el-checkbox v-model="query.is_visibility">仅显示可见</el-checkbox>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :height="tableHeight"
                v-loading="loading"
                :data="list"
                stripe border style="width: 100%">
                <el-table-column prop="id" label="ID" align="center" width="210">
                </el-table-column>

                <el-table-column prop="name" label="项目名" align="center">
                </el-table-column>

                <el-table-column prop="description" label="描述" align="center">
                </el-table-column>

                <el-table-column prop="created" label="创建时间" align="center" width="170">
                </el-table-column>

                <el-table-column label="用户" width="220" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div v-for="item in scope.row.user">
                                <div>{{ item.username }} {{ item.full_name }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="220">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click.native="handleDetail(scope.$index, scope.row)">进入项目
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                           :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"
                           style="margin-top: 10px;display: flex;justify-content: end;"
                           layout="total, sizes, prev, pager, next">
            </el-pagination>
        </div>
        <div v-if="pageType == 2">
            <enterProject :childData="childData" @goBackList="goBackList"></enterProject>
        </div>
    </div>

</template>

<script>
    import {downloadFileUrl} from '@/utils/method'
    import * as api from '@/api/advAnalys/advAnalys.js'
    import enterProject from './enterProject'

    export default {
        components: {enterProject},
        data() {
            return {
                childData: {},
                pageType: 1,
                tableHeight: null,
                addSubLibraryModal: false,
                query: {
                    name: '',
                    is_visibility: true,
                    page: 1,
                    limit: 20
                },
                list: [],
                total: 0,
                loading: true,
                authList: [],
                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                authLoading: false,
                authFormVisible: false,
                authFormData: {
                    role_id: '',
                    auth_rules: []
                },
                authDefaultCheckedKeys: [],
                index: null,
                formName: null,
                formMap: {
                    add: '新增角色',
                    edit: '编辑'
                },
                formLoading: false,
                formVisible: false,
                formRules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ]
                },
                deleteLoading: false
            }
        },
        computed: {
            showAsinSupervisor() {
                return this.$checkPermission('logistics_asin_supervisor')
            },
        },
        methods: {
            goBackList() {
                this.pageType = 1
            },
            handleDetail(index,data) {
                this.pageType = 2
                data.sub_index = 1
                this.childData = data
            },
            // 关闭弹窗回调
            closeCllback(isShow) {
                this.addSubLibraryModal = false
                isShow == true && this.getList()
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            onReset() {
                this.query = {
                    name: '',
                    is_visibility: true,
                    page: 1,
                    limit: 20
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            personInCharge(){
                this.$refs.personInChargeModal.showModal()
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                let tempQuery = JSON.parse(JSON.stringify(this.query))
                tempQuery.is_visibility = tempQuery.is_visibility ? 1 : 0
                api.admin_teambition_project_lists(tempQuery)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            },
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        created() {
            // 加载表格数据
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
</style>
